import {getOpenModalMethod} from "util/modals/modalHelpers";
import {getFlag, setFlag} from "src/components/organisms/DownloadUniversal/Utils/utils";
import {sendGaEvent} from "util/ga/gaHelpers";

const intervalSettings = {
    showInterval: 1 * 24 * 60 * 60 * 1000,
    showsLimit: 3,
    showsLimitResetDelay: 60 * 24 * 60 * 60 * 1000,
}

export const ContainerSecurityModalMethod = getOpenModalMethod({
    modalId: "container-security-modal",
    modalDelay: 10000, 
    modalIntervalSettings: {
        showInterval: 1,
        showsLimit: 1,
        showsLimitResetDelay: 24 * 60 * 60 * 1000,
    },
    allowedToOpen: () => !getFlag('container-security-submitted') 
})

export const SpringSecurityModalMethod = getOpenModalMethod({
    modalId: "spring-security-modal",
    modalDelay: 10000, 
    modalIntervalSettings: {
        showInterval: 1,
        showsLimit: 1,
        showsLimitResetDelay: 24 * 60 * 60 * 1000,
    },
    allowedToOpen: () => !getFlag('spring-security-submitted') 
})


export const WebinarSpringModalMethod = getOpenModalMethod({
    modalId: 'popup-spring-webinar',
    modalDelay: 5000,
    modalIntervalSettings: {
        showInterval: 1 * 24 * 60 * 60 * 1000,
        showsLimit: 1,
        showsLimitResetDelay: 1 * 24 * 60 * 60 * 1000,
    },
    allowedToOpen: () => !getFlag('webinar-spring-submitted')
})

export const tryJdk8PerfModalMethod = getOpenModalMethod({
    modalId: "popup-get-jdk-8-perf",
    modalGroup: "popup-get-jdk-perf",
    modalDelay: 800,
    modalIntervalSettings: intervalSettings,
    onOpen: () => {
        sendGaEvent({
            'event': 'custom_event',
            'event_category': 'forms',
            'event_action': 'pop_up_window_liberica_perf',
            'event_label': 'links_on_downloads_page'
        })
    }
})

export const tryJdk11PerfModalMethod = getOpenModalMethod({
    modalId: "popup-get-jdk-11-perf",
    modalGroup: "popup-get-jdk-perf",
    modalDelay: 800,
    modalIntervalSettings: intervalSettings,
    onOpen: () => {
        sendGaEvent({
            'event': 'custom_event',
            'event_category': 'forms',
            'event_action': 'pop_up_window_liberica_perf',
            'event_label': 'links_on_downloads_page'
        })
    }
})

export const tryJdkPerfModalAfterDownloadMethod = getOpenModalMethod({
    modalId: Boolean(getFlag("downloaded-jdk-8")) ? "popup-get-jdk-8-perf" : "popup-get-jdk-11-perf",
    modalGroup: "popup-get-jdk-perf",
    modalDelay: 7000,
    modalIntervalSettings: intervalSettings,
    allowedToOpen: () => {
        return Boolean(getFlag("downloaded-jdk-11") || getFlag("downloaded-jdk-8"))
    },
    onOpen: () => {
        sendGaEvent({
            'event': 'custom_event',
            'event_category': 'forms',
            'event_action': 'pop_up_window_liberica_perf',
            'event_label': 'links_on_downloads_page'
        })
    }
})

export const tryPopupGartnerAfterDownload = getOpenModalMethod({
    modalId: "popup-like-our-products",
    modalGroup: "popup-get-jdk-perf",
    modalDelay: 10,
    modalIntervalSettings: intervalSettings,
    allowedToOpen: () => {
        return Boolean(getFlag("downloaded-jdk"))
    },
    // onOpen: () => {
    //     sendGaEvent({
    //         'event': 'custom_event',
    //         'event_category': 'forms',
    //         'event_action': 'pop_up_window_liberica_perf',
    //         'event_label': 'links_on_downloads_page'
    //     })
    // }
})

export const jrushModal = getOpenModalMethod({
    modalId: "popup-register-to-jrush-modal-2026",
    modalDelay: 15000,
    modalIntervalSettings: {
        showInterval: 1,
        showsLimit: 1,
        showsLimitResetDelay: 24 * 60 * 60 * 1000,
    },
    allowedToOpen: () => !getFlag('jrush-submitted-2026')
})


export const jrushModalMethod = getOpenModalMethod({
    modalId: "popup-jrush-update-modal-2025",
    modalGroup: "popup-jrush",
    modalDelay: 15000,
    modalIntervalSettings: {
        showInterval: 0,
        showsLimit: 3,
        showsLimitResetDelay: 1 * 24 * 60 * 60 * 1000,
    },
    allowedToOpen: () => !getFlag("jrush-form-submitted-2025")
})

// показывается сразу после скачки 
export const jrushUpdateModalMethodForDownloads = getOpenModalMethod({
    modalId: "popup-jrush-update-modal-2025",
    modalDelay: 10, // через сколько показывается
    modalIntervalSettings: {
        showInterval: 0,
        showsLimit: 1,
        showsLimitResetDelay: 60 * 24 * 60 * 60 * 1000
    },
    onOpen: () => setFlag("juum-opened"),
    allowedToOpen: () => !getFlag('jrush-update-modal-submitted') && Boolean(!getFlag('juum-opened'))
})

// показывается через 15 сек после захода на блог
export const jrushUpdateModalMethodForBlog = getOpenModalMethod({
    modalId: "popup-jrush-update-modal-2025",
    modalDelay: 15000, // через сколько показывается
    modalIntervalSettings: {
        showInterval: 0,
        showsLimit: 1,
        showsLimitResetDelay: 60 * 24 * 60 * 60 * 1000
    },
    onOpen: () => setFlag("juum-opened"),
    allowedToOpen: () => !getFlag('jrush-update-modal-submitted') && Boolean(!getFlag('juum-opened'))
})

export const jrushUpdateModalMethodRetry = getOpenModalMethod({
    modalId: "popup-jrush-update-modal-2025",
    modalDelay: 10000, // через сколько показывается
    modalIntervalSettings: {
        showInterval: 3 * 24 * 60 * 60 * 1000, // 3 days
        showsLimit: 4,
        showsLimitResetDelay: 60 * 24 * 60 * 60 * 1000 // 60 days
    },
    allowedToOpen: () => !getFlag('jrush-update-modal-submitted') && Boolean(getFlag('juum-opened'))
})

export const webinarModalMethod = getOpenModalMethod({
    modalId: "popup-register-to-webinar-modal",
    modalDelay: 5000,
    modalIntervalSettings: {
        showInterval: 1 * 24 * 60 * 60 * 1000,
        showsLimit: 10,
    },
    allowedToOpen: () => {
        return Boolean(getFlag("downloaded-jdk-11") || getFlag("downloaded-jdk-8"))
    },
    onOpen: () => {
        sendGaEvent({
            'event': 'custom_event',
            'event_category': 'forms',
            'event_action': 'pop_up_window_register_to_webinar',
            'event_label': 'popup_show'
        })
    }
})

export const wrongDomainModalMethod = getOpenModalMethod({
    modalId: "wrong-domain",
    modalDelay: 1000,
    allowedToOpen: () => {
        const loc = window.location.hostname;
        return !loc.endsWith(atob("YmVsbC1zdy5jb20=")) && !(loc === "localhost")
    },
    modalIntervalSettings: {
        showsLimit: 0,
        showInterval: 0
    }
})
